export const GET_CONTRACTS_BY_STOCK = 'GET_CONTRACT_BY_STOCK';
export const GET_CONTRACTS_BY_STOCK_SUCCESS = 'GET_CONTRACT_BY_STOCK_SUCCESS';
export const GET_CONTRACTS_BY_STOCK_FAIL = 'GET_CONTRACT_BY_STOCK_FAIL';

export const UPDATE_CONTRACT = 'UPDATE_CONTRACT';
export const UPDATE_CONTRACT_SUCCESS = 'UPDATE_CONTRACT_SUCCESS';
export const UPDATE_CONTRACT_FAIL = 'UPDATE_CONTRACT_FAIL';

export const DELETE_CONTRACT = 'DELETE_CONTRACT';
export const DELETE_CONTRACT_SUCCESS = 'DELETE_CONTRACT_SUCCESS';
export const DELETE_CONTRACT_FAIL = 'DELETE_CONTRACT_FAIL';

export const ADD_CONTRACT = 'ADD_CONTRACT';
export const ADD_CONTRACT_SUCCESS = 'ADD_CONTRACT_SUCCESS';
export const ADD_CONTRACT_FAIL = 'ADD_CONTRACT_FAIL';
